module.exports = __webpack_public_path__ + "img/hm_block01_en.2b536603.jpg";